import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_FINANCIAL_SUBCATEGORIES](state, data) {
    state.allFinancialSubCategories = data
  },
}
